export const HIGH_VOLUME_PLAN_CODE = 'highvolume';
export const ENTERPRISE_PLAN_CODE = 'enterprise';
export const PLATINUM_PLAN_CODE = 'platinum';
export const GOLD_PLAN_CODE = 'gold';
export const SILVER_PLAN_CODE = 'silver';
export const BRONZE_PLAN_CODE = 'bronze';
export const STARTER_PLAN_CODE = 'starter';
export const STARTUP_PLAN_CODE = 'startup';
export const SCALE_PLAN_CODE = 'scale';
export const TRIAL_PLAN_CODE = 'trial';
